import React from "react";
import * as Mui from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";
import { IconProps } from "react-feather";

/**
 * The AI sparkle that marks Search Agent features. react-feather has no sparkle, so the glyph is
 * drawn here once and offered in both shapes the app renders icons in.
 */

const star = "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275z";
const glints = ["M5 3v4", "M19 17v4", "M3 5h4", "M17 19h4"];

const Glyph = () => (
	<>
		<path d={star} fill="currentColor" />
		<g fill="none">
			{glints.map((d) => <path key={d} d={d} />)}
		</g>
	</>
);

/** A Mui.SvgIcon, for MUI surfaces such as tab labels and card headers. */
export const SparkleIcon = (props: SvgIconProps) => (
	<Mui.SvgIcon viewBox="0 0 24 24" {...props}>
		<g stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
			<Glyph />
		</g>
	</Mui.SvgIcon>
);

/**
 * A drop-in for a react-feather icon component, for places typed as one — lead activity types,
 * and anything else rendered inside FeatherIcon.
 */
export const SparkleFeatherIcon = ({ color = "currentColor", size = 24, ...others }: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		stroke={color}
		strokeWidth={1.5}
		strokeLinecap="round"
		strokeLinejoin="round"
		{...others}
	>
		<Glyph />
	</svg>
);
